import { DomUtils } from './dom.utils';

export class MiradiUtils {

  /** @deprecated */
  static concatenateIdAndName(id: string, name: string, keepLineBreaks?: boolean) {
    if (keepLineBreaks) {
      return (id || '') + (id && name ? '. ' : '') + DomUtils.decodeText((name || '').replace(/<br\/*>/g, '\n'), keepLineBreaks).replace(/\n/g, '<br>');
    } else {
      return (id || '') + (id && name ? '. ' : '') + DomUtils.decodeText((name || ''));
    }
  }

  static concatenateIdAndNameV2(factor: { identifier?: string, name?: string }, keepLineBreaks?: boolean) {
    if (keepLineBreaks) {
      return (factor?.identifier || '') + (factor?.identifier && factor?.name ? '. ' : '') + DomUtils.decodeText((factor?.name || '').replace(/<br\/*>/g, '\n'), keepLineBreaks).replace(/\n/g, '<br>');
    } else {
      return (factor?.identifier || '') + (factor?.identifier && factor?.name ? '. ' : '') + DomUtils.decodeText((factor?.name || ''));
    }
  }

  static sort(a: any, b: any): number {
    const aString = (a.data?.factor?.identifier || '') + DomUtils.decodeText(a.data?.factor?.name || '');
    const bString = (b.data?.factor?.identifier || '') + DomUtils.decodeText(b.data?.factor?.name || '');

    return aString.localeCompare(bString);
  }

}
